import { workStatusList, workStatusListName } from '@/scripts/consts'
import { mapGetters } from 'vuex'

export const isEffContractMixin = {
  data() {
    return {}
  },

  computed: {
    ...mapGetters('user', ['isAdmin', 'isModerator', 'isModeratorNir']),

    isWorkAccepted() {
      return [workStatusListName.Accepted].includes(workStatusList[this.currentWork.commonWork.status?.id])
    },

    userCanChangeIsEffContract() {
      return this.isAdmin || this.isModerator || this.isModeratorNir
    },

    canChangeIsEffContractInShowMode() {
      return this.userCanChangeIsEffContract && this.isWorkAccepted
    },

    isEffContractVisibility() {
      return this.userCanChangeIsEffContract || this.isWorkAccepted
    }
  }
}
